import React, { useState, useEffect, useRef } from 'react'
import constants from "../constants";
import page from '../css/service.css'
import $ from 'jquery';
import useSlider from "../hooks/useSlider"

const Service = () => {

    const [isMobile, setIsMobile] = useState();

    const papynosSliderRef = useSlider(isMobile);
    const moneeySliderRef = useSlider(isMobile);
    const mounted = useRef()
    useEffect(() => {
        // mounted.current = true
        setIsMobile(window.innerWidth <= 768)
        window.addEventListener('resize', handleResize);

        // 컴포넌트 언마운트 시 이벤트 해제
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
    };


    return (
        <>
            <div className="service">
                <main>
                    {/* 파피노스 */}
                    <section className="tpi bg_02">
                        <div className="wrp flx-center">
                            <div className="msg">
                                <div className="tit">서비스 소개</div>
                                <div className="mit">(주)핀테크의 다양한 서비스를 만나보세요.</div>
                            </div>
                        </div>
                    </section>
                    <div className="container">
                        <section>
                            <div className="tab-btn">
                                <button type="button" className="btn-bg blue" onClick={() => {
                                    document.querySelector('#papynos').scrollIntoView({ behavior: 'smooth' });
                                }}>파피노스</button>
                                <button type="button" className="btn-border gray" onClick={() => {
                                    document.querySelector('#moneey').scrollIntoView({ behavior: 'smooth' });
                                }}>모니</button>
                            </div>
                        </section>
                    </div>
                    <div className="container" id="papynos">
                        <section className="bg-skyblue">
                            <div className="wrp">
                                <div className="name-section">
                                    <p className="name-title">파피노스</p>
                                    <p className="name-sub">복잡한 서류수집과정은 자동화로 간편하게!<br />‘모바일 대출’ 구축, 쉽게 도입하고 {isMobile && <br />}빠르게 시작하세요!</p>
                                    <div className="wrp-btn">
                                        <a href={constants.papaynosGooglePlayUrl} target="_blank" className="btn-bg blue icon"><i className="icon-google-play"></i><span>구글플레이</span></a>
                                        <a href={constants.papaynosAppStoreUrl} target="_blank" className="btn-bg blue icon"><i className="icon-app-store"></i><span>앱스토어</span></a>
                                    </div>
                                </div>
                                <div className="img-section">
                                    <i className="img-service-papaynos"></i>
                                </div>
                            </div>
                        </section>
                        <div className="wrp">
                            <div className="main-title">
                                <i className="icon-logo-papynos"></i>
                                <p>모바일로 쉽고 간편하게<br />빠른 서류 수집부터 {isMobile && <br />}간편제출까지!</p>
                            </div>
                        </div>
                        <section className="bg-green">
                            <div className="wrp">
                                {isMobile && <div className="bg-green"></div>}
                                <ul className="mobile-section" ref={papynosSliderRef}>
                                    <li><i className="img-mobile-papynos01"></i></li>
                                    <li><i className="img-mobile-papynos02"></i></li>
                                    <li><i className="img-mobile-papynos03"></i></li>
                                </ul>
                            </div>
                        </section>
                        <div className="wrp">
                            <div className="align-center">
                                <p className="text">복잡한 서류 수집 과정은 자동화로 {isMobile && <br />}간편하게 동적안면인식, 전자서명 등<br />
                                    강력한 본인확인으로 혁신적인 {isMobile && <br />}모바일대출 서비스가 가능한 플랫폼입니다.</p>
                            </div>
                        </div>
                    </div>

                    {/* 모니 */}
                    <div className="container" id="moneey">
                        <section className="bg-skyblue">
                            <div className="wrp">
                                <div className="name-section">
                                    <p className="name-title">모니</p>
                                    <p className="name-sub">내 자산을 한번에 확인 가능하며,<br />마이데이터를 활용한 금융, 생활편의 정보 제공</p>
                                    <div className="wrp-btn">
                                        <a href={constants.monneyGooglePlayUrl} target="_blank" className="btn-bg blue icon"><i className="icon-google-play"></i><span>구글플레이</span></a>
                                        <a href={constants.monneyAppStoreUrl} target="_blank" className="btn-bg blue icon"><i className="icon-app-store"></i><span>앱스토어</span></a>
                                    </div>
                                </div>
                                <div className="img-section">
                                    <i className="img-service-moneey"></i>
                                </div>
                            </div>
                        </section>
                        <div className="wrp">
                            <div className="main-title">
                                <i className="icon-logo-moneey"></i>
                                <p>한눈에 보는 나의 금융생활,</p>
                                <p>쉬운 마이데이터, {isMobile && <br />}간편한 일상 !</p>
                            </div>
                        </div>
                        <section className="bg-blue">
                            <div className="wrp">
                                {isMobile && <div className="bg-blue"></div>}
                                <ul className="mobile-section" ref={moneeySliderRef}>
                                    <li><i className="img-mobile-moneey01"></i></li>
                                    <li><i className="img-mobile-moneey02"></i></li>
                                    <li><i className="img-mobile-moneey03"></i></li>
                                </ul>
                            </div>
                        </section>
                        <div className="wrp">
                            <div className="align-center">
                                <p className="text">내 자산정보, My Stockmanager,{isMobile && <br />} 정부지원금, 전자증명서 발급 등<br />
                                    마이데이터를 활용한 금융,{isMobile && <br />} 생활편의 정보를 제공하는 플랫폼입니다.</p>
                            </div>
                        </div>
                    </div>
                </main>
            </div>

        </>
    );

};

export default Service;